import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/password`;

export const passwordHandlers = [
  http.post(`${baseUrl}/reset_request`, async ({ request }) => {
    const { email } = (await request.json()) as Required<{
      email: string;
      individual?: boolean;
    }>;

    if (email === 'error@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: 'メールアドレスを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
  http.post(`${baseUrl}/reset`, async ({ request }) => {
    const { token, password, password_confirmation } =
      (await request.json()) as Required<{
        token: string;
        password: string;
        password_confirmation: string;
      }>;
    if (password !== password_confirmation) {
      return HttpResponse.json(
        { error_type: 'error', message: 'パスワードが一致しません。' },
        { status: 400 }
      );
    } else if (token !== 'correct-token') {
      return HttpResponse.json(
        { error_type: 'error', message: '不正なトークンです。' },
        { status: 401 }
      );
    } else if (password === 'errorpass') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [{ field: 'password', message: 'パスワードエラー。' }],
        },
        { status: 400 }
      );
    } else {
      return HttpResponse.json({ success: true });
    }
  }),
  // トークンの有効性チェック
  http.post(`${baseUrl}/validate_token`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      token: string;
    };
    console.info(postRequest);

    if (postRequest.token === 'invalid_token') {
      return HttpResponse.json(
        { error_type: 'error', message: '不正なトークンです。' },
        { status: 400 }
      );
    } else {
      return new HttpResponse(null, { status: 200 });
    }
  }),
];
